export default "__VITE_ASSET__XA_9Pqo1__"